import {
    APPROVE_TIMECARD,APPROVE_TIMECARD_LOADING,APPROVE_TIMECARD_FAIL,  APPROVE_ALL_TIMECARDS,
    APPROVE_ALL_TIMECARDS_LOADING,
    APPROVE_ALL_TIMECARDS_FAIL,
  } from "./../actions/actionTypes";

  const DEFAULT_STATE = {
    isDataLoaded:false,
    isLoading: false,
    timecard: {},
    error: {},
    isAllTimecardsLoading: false
  };
  
export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case APPROVE_TIMECARD_LOADING:
      return { ...state, isLoading: true };
    case APPROVE_TIMECARD:
      return {
        ...state,
        isLoading: false,
        isDataLoaded:true,
        timecard: action.timecard
      };
    case APPROVE_TIMECARD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
      case APPROVE_ALL_TIMECARDS_LOADING:
        return { 
          ...state, 
          isAllTimecardsLoading: true 
        };
      case APPROVE_ALL_TIMECARDS:
        return {
          ...state,
          isAllTimecardsLoading: false,
          timecardsStatus: action.timecardsStatus
        };
      case APPROVE_ALL_TIMECARDS_FAIL:
        return {
          ...state,
          isAllTimecardsLoading: false,
          error: action.error
        }
    default:
      return state;
  }
};
  